import { TFeedItem } from 'types/TFeeds';

const CARS_PARENT_CATEGORY_ID = 91;

const isCarItem = (item: TFeedItem): boolean => {
  return item.category?.parentId === CARS_PARENT_CATEGORY_ID;
};

export default isCarItem;
